module.exports = __webpack_public_path__ + "static/blue-arrow-f93ac802941259873ac049aa40ae7120.png";